import React, { Component } from 'react'
import { Link }             from 'react-router-dom'

import Meta        from './components/meta'
import Search      from './components/search'
import Content     from './components/content'
import Attachments from './components/attachments'

import './css/archive.css'

export default class Archive extends Component {

  state = {}

  componentDidMount() {
    this.load(this.props)
  }

  componentWillReceiveProps(props) {
    this.load(props)
  }

  load(props) {
    if (props.catalog) {
      let byDate = {}
      props.catalog.items.forEach(image => {
        if (!byDate[image.date]) {
          byDate[image.date] = []
        }
        byDate[image.date].push(image)
      })
      this.categories = Object.keys(byDate).map(date => ({title: date, items: byDate[date]}))
      props.catalog.unfinished && this.categories.push({
        title: props.catalog.catalog_unfinished_title,
        items: props.catalog.unfinished,
      })
      props.catalog.series && this.categories.push({
        title       : props.catalog.catalog_series_title,
        description : props.catalog.catalog_series_description,
        items       : props.catalog.series.items,
        noLink      : true,
      })
    } else {
      this.categories = props.section.categories
    }
    this.setState({categories: this.categories})
  }

  filter(query) {
    if (!query) {
      this.setState({categories: this.categories})
    } else {
      this.setState({categories: this.categories.map(category => ({
        title: category.title,
        items: category.items.filter(item => item.search.indexOf(query) !== -1),
      }))})
    }
  }

  render() {
    let title  = this.props.catalog ? this.props.catalog.catalog_title  : this.props.section.title
    let prolog = this.props.catalog ? this.props.catalog.catalog_prolog : undefined
    return !this.state.categories ? '' : (
      <div className="archive">
        <Meta data={this.props.data} item={this.props.section} />
        <h1 className="archive-title">{title}</h1>
        {prolog && (
          <Content text={prolog} brightnessHint={this.props.data.content.brightness_hint} />
        )}
        {this.state.categories.length > 1 && (
          <CategoryLinks data={this.props.data} categories={this.state.categories} catalog={this.props.catalog} />
        )}
        <Search data={this.props.data} section={this.props.section} filter={this.filter.bind(this)} />
        {this.state.categories.map((category, n) => !(category.items && category.items.length > 0) ? '' : (
          <Category key={n} id={n+1} data={this.props.data} category={category} catalog={this.props.catalog} />
        ))}
      </div>
    )
  }

}

class CategoryLinks extends Component {
  
  render() {
    return (
      <div className="archive-category-links">
        {this.props.categories.map((category, n) => !category.noLink && category.items.length > 0 && (
          <div key={n} className="archive-category-link" onClick={() => this.click(n+1)}>{category.title}</div>
        ))}
      </div>
    )
  }

  click(id) {
    window.scroll({behavior: 'smooth', left: 0, top: document.getElementById(id).offsetTop})
  }

}

function Category(props) {
  return (
    <div className="archive-category">
      {props.category.title && (
        <h2 id={props.id} className="archive-category-title">{props.category.title}</h2>
      )}
      {props.category.description && (
        <Content text={props.category.description} />
      )}
      {props.category.heading && (
        <h3 className="archive-heading">{props.category.heading}</h3>
      )}
      <div className="archive-rows">
        {props.category.items.map((item, n) => (
          <Row key={n} item={item} data={props.data} catalog={props.catalog} />
        ))}
      </div>
    </div>
  )
}

function Row(props) {
  return (
    <div className="archive-row">
      {props.item.thumb_url && (
        <div className="archive-row-image">
          <img
            src   = {props.item.thumb_url}
            alt   = {props.item.title || props.item.name}
            title = {props.item.title || props.item.name}
          />
        </div>
      )}
      <div className="archive-row-data">
        {props.item.section && props.item.section.tag === 'news' && (
          <h4 className="archive-row-date">{props.item.date}</h4>
        )}
        {(props.item.title || props.item.name) && (
          <h3 className="archive-row-title">
            {props.item.url ? <Link to={props.item.url}>{props.item.title || props.item.name}</Link> : props.item.title || props.item.name}
            {props.item.section.tag !== 'news' && props.item.date && (
              <span className="archive-row-title-date">{props.item.date}</span>
            )}
          </h3>
        )}
        {(props.item.author || props.item.location) && (
          <h4 className="archive-row-subtitle">{props.item.author || props.item.location}</h4>
        )}
        {props.item.text && (
          <Content text={props.item.text} />
        )}
        {props.catalog && props.item.description && (
          <Content text={props.item.description} />
        )}
        {props.catalog && props.item.variants && props.item.variants.length > 0 && (
          <Category category={{heading: props.data.content.variants_title, items: props.item.variants}} data={props.data} catalog={props.catalog} />
        )}
        {props.catalog && props.item.sketches && props.item.sketches.length > 0 && (
          <Category category={{heading: props.data.content.sketches_title, items: props.item.sketches}} data={props.data} catalog={props.catalog} />
        )}
        {props.catalog && props.item.images && props.item.images.length > 0 && (
          <div className="archive-attachments">
            <Attachments attachments={props.item.images} />
          </div>
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/archive.js